import {
  Box, Card, CardActions, Grid, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: theme.palette.background.card,
    maxWidth: 330,
    minWidth: 330,
    minHeight: 219,
    padding: theme.spacing(0, 4),
    borderRadius: '12px',
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(4, -2, 1.7, 6),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(6, 5.5),
    },
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    padding: theme.spacing(1, 5),
    borderRadius: '8px',
  },
  buttonMentor: {
    padding: theme.spacing(1, 10),
    borderRadius: '8px',
  },
  text: {
    fontSize: '24px',
    fontFamily: 'Raleway',
    fontWeight: '600',
  },
  mentor: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.background.card,
    maxWidth: 330,
    minWidth: 330,
    minHeight: 219,
    color: theme.palette.common.white,
    padding: theme.spacing(0, 4),
    margin: theme.spacing(6),
    borderRadius: '12px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(0, 1),
  },
  disableCard: {
    position: 'absolute',
    backdropFilter: 'blur(4px)',
    background: '#0f101150',
    minWidth: 394,
    minHeight: 219,
  },
}));

function SkeletonTools() {
  const classes = useStyles();
  return (
    <Grid
      className={classes.container}
    >
      <Card className={classes.card}>
        <Box className={classes.title}>
          <Typography className={classes.text}>
            <Skeleton variant="rect" width={170} height={35} />
          </Typography>
          <CardActions>
            <Box variant="contained">
              <Skeleton variant="rect" width={100} height={40} />
            </Box>
          </CardActions>
        </Box>
        <Box>
          <Skeleton variant="circle" width={90} height={90} />
        </Box>
      </Card>
    </Grid>
  );
}

export default SkeletonTools;
